import heic2any from 'heic2any';
import { getPlatformType, getPlatformUrl } from "@/utils/ql_platform";

export function useImgUrl(imgUrl: any) {
	if (!imgUrl) return "数据错误";
	const ql_platform_type = getPlatformType();
	if (imgUrl.includes("https://")) {
		return imgUrl;
	} else if (ql_platform_type) {
		const uri = getPlatformUrl(ql_platform_type)?.uri;
		return (uri || import.meta.env.VITE_IMG_URL) + imgUrl;
	} else {
		return `${import.meta.env.VITE_IMG_URL}${imgUrl}`;
	}
}

export function useThemeImgUrl(imgUrl: any) {
	const themeCode = "default";
	return `/image/${themeCode}/${imgUrl}`;
}

/**
 * 对heic格式的文件进行特殊处理，将其转换为jpg格式
*/
export async function conversionFormat(file: File) {
	let jpgFile;
	try {
		// 1. HEIC -> JPEG Blob
		const result = await heic2any({
			blob: file,
			toType: 'image/jpeg',
			quality: 0.9,
		});
		// 如果是数组，取第一个（大多数 HEIC 图片只有一帧）
		const jpgBlob = Array.isArray(result) ? result[0] : result;
		// 2. 转为 File 对象
		const convertedFile = new File([jpgBlob], file.name.replace(/\.heic$/i, '.jpg'), {
			type: 'image/jpeg',
		});

		jpgFile = convertedFile;
	} catch (error) {
		console.error('heic转换失败:', error);
		return file;
	}
	return jpgFile;
};
